import axios from "./configs/axiosConfig";

export const getUserDetails = async (emailid) => {
  const url = `user?email=${encodeURIComponent(emailid)}`;
  return await axios.get(url);
};

export const updateUserTrems = async (id,isTermsAccepted) => {
  const url = `user/updateterms `;
  return await axios.put(url,{
    "id": id,
    "isTermsAccepted": isTermsAccepted
  });
};